import type { ExpressionSpecification } from "mapbox-gl";

/**
 * Shared greyed-out paint for strategy layers (fuel load, vegetation) while a
 * fuel recalculation is in flight: the layer keeps showing its retained tiles
 * (see useRetainedTilesUrl) with each feature's own colour mixed most of the
 * way toward grey — clearly stale, but polygons stay distinguishable (a flat
 * grey erased them entirely).
 */
export const RECALC_GREY = "#9e9e9e";
/** Fraction of the way each feature colour is pulled toward RECALC_GREY. */
export const RECALC_GREY_MIX = 0.65;

/** Mix a (possibly data-driven) colour toward grey by RECALC_GREY_MIX. */
export const recalcGreyed = (
  color: ExpressionSpecification | string
): ExpressionSpecification =>
  [
    "interpolate",
    ["linear"],
    RECALC_GREY_MIX,
    0,
    color,
    1,
    RECALC_GREY,
  ] as ExpressionSpecification;
